import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import imageConfig from '../utils/imageConfig';
import { getCategoryForItem } from '../utils/categories';
import { FaShoppingCart, FaCheck } from 'react-icons/fa';

const SnackItem = ({ item, onItemAdded }) => {
  const { addToCart, cartItems } = useCart();
  const [isAdding, setIsAdding] = useState(false);
  const imageName = imageConfig[item.Id] || 'default.jpg';
  const imagePath = `/assets/images/${imageName}`;
  const category = getCategoryForItem(item);
  
  // Check if item is already in cart
  const itemInCart = cartItems.find(cartItem => cartItem.Id === item.Id);
  const itemQuantity = itemInCart ? itemInCart.quantity : 0;
  
  // Format price from cents to dollars/currency
  const formatPrice = (priceInCents) => {
    return (priceInCents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'KES'
    });
  };

  const handleAddToCart = () => {
    setIsAdding(true);
    addToCart(item);
    
    // Show animation effect
    setTimeout(() => {
      setIsAdding(false);
      // Notify parent component to show cart modal
      if (onItemAdded) {
        onItemAdded();
      }
    }, 300);
  };

  return (
    <div className="snack-item">
      <div className="snack-image">
        <img src={imagePath} alt={item.Description} onError={(e) => {
          e.target.onerror = null;
          e.target.src = '/assets/images/default.jpg';
        }} />
        <div className="category-badge">{category}</div>
        {itemQuantity > 0 && (
          <div className="cart-badge">{itemQuantity}</div>
        )}
      </div>
      <div className="snack-details">
        <h3>{item.Description}</h3>
        <p className="snack-price">{formatPrice(item.PriceInCents)}</p>
      </div>
      <button 
        className={`add-to-cart-btn ${isAdding ? 'adding' : ''} ${itemInCart ? 'in-cart' : ''}`}
        onClick={handleAddToCart}
        aria-label="Add to cart"
      >
        {itemInCart ? (
          <>
            <FaCheck className="icon-left" /> 
            <span>Add More</span>
          </>
        ) : (
          <>
            <FaShoppingCart className="icon-left" />
            <span>Add to Cart</span>
          </>
        )}
      </button>
    </div>
  );
};

export default SnackItem;
